import RadioComponent from '~/common/components/Radios/Radio';
import RadioGroup from '~/common/components/Radios/RadioGroup';

import ProcessedText from '../utilityComponents/ProcessedText';

type RadioProps = {
  field?: any;
  question?: any;
  isInvalid?: boolean;
};

export default function Radio({
  field,
  question,
  isInvalid,
}: Readonly<RadioProps>) {
  const { options, name } = question;
  return (
    <RadioGroup display={'flex'} {...field}>
      {options.map((option) => (
        <RadioComponent
          key={option.value}
          name={name}
          value={option.value}
          isInvalid={isInvalid}
          marginRight={'1rem'}
          data-testid={`${name}-${option.value}`}
        >
          <ProcessedText
            text={option.label}
            placeholders={option.placeholders}
          />
        </RadioComponent>
      ))}
    </RadioGroup>
  );
}
